import SolutionItem from './SolutionItem';

export default SolutionItem;
